class batchFilterService {
    constructor(sweetalert, httpRequest, logger) {
        this.sweetalert = sweetalert
        this.httpRequest = httpRequest
        this.logger = logger
        this.tips = '审核状态为“审核通过”、“审核中”的不允许操作' //销售单删除、作废 、提交
        //不是“审核通过”状态，不支持回退操作
        // 只能对已过期单据进行激活 
    }
    /**
     * config : 
     * condition 过滤条件 ：{word:'' ,val: ''}
     * API 接口名称
     */
    ovatBatchFilter(list, config) {
        if (config.text == '回退') {
            this.tips = '不是“审核通过”状态不允许操作'
        } else if (config.text == '激活') {
            this.tips = '不是已过期单据不允许操作'
        } else if (config.isCancel) { //销售单作废
            this.tips = '红票或已作废单据不允许操作'
        } else if (config.isSubmit) { //销售单提交
            this.tips = '已作废单据不允许操作'
        }else if(config.isDelete){ //销售单删除
            this.tips ='待提交的红票不允许操作'
        }
         else {
            this.tips = '审核状态为“审核通过”、“审核中”的不允许操作'
        }
        return new Promise((resolve, reject) => {
            const arr = list.filter((i, index) => {
                let flag = false
                if (config.condition.word == 'billStatus' && i[config.condition.word] == config.condition.val) {
                    flag = true
                } else if (config.condition.word != 'billStatus' && i.authMap[config.condition.word] == config.condition.val) flag = true
                return flag //筛选出符合条件的
            })
            if (arr.length && arr.length != list.length) { //部分符合条件
                this.sweetalert.confirm('操作提醒',
                    `本次选择了${list.length}条数据,符合条件的有${arr.length}条,不符合条件的有${list.length - arr.length}条,是否继续执行符合条件的数据<br><br>
                 不符合原因：<br>${this.tips}
                 `).then(() => {
                    resolve(arr)
                }, () => {
                    reject()
                })
            } else if (!arr.length) { //全部不符合
                this.logger.logError(`选择的数据全部不符合条件,不符合原因:<br>${this.tips}`)
                reject()
            } else { //全部符合
                resolve(arr)
            }
        })
    }
}
batchFilterService.$inject = ['sweetalert', 'httpRequest', 'logger']
export default batchFilterService


// WEBPACK FOOTER //
// ./src/common/services/batchFilterService.js